<template>
    <section v-if="newBizParam">
        <!-- 规则1 start-->
        <div class="rule">
            <el-checkbox @change="changeCheck(1);$emit('changeData',newBizParam)" v-model="newBizParam.dayBizDataSum.enabled"></el-checkbox>
            <span class="txt">规则1：同一人同一天提交库存条数最多</span>
            <div
                :class="!newBizParam.dayBizDataSum.limitMax && newBizParam.dayBizDataSum.enabled && isOpenCheck ? 'red-border' : ''">
                <el-input :disabled="!newBizParam.dayBizDataSum.enabled" class="rule-input-box"
                    v-model="newBizParam.dayBizDataSum.limitMax" @input="$forceUpdate();$emit('changeData',newBizParam)"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text" :min="1" :maxlength="7"></el-input>
            </div>

            <span class="txt">条</span>
            <p class="tips"
                v-if="!newBizParam.dayBizDataSum.limitMax && newBizParam.dayBizDataSum.enabled && isOpenCheck">
                请将规则填写完整</p>
        </div>
        <!-- 规则1 end-->

        <!-- 规则2 start-->
        <div class="rule">
            <el-checkbox @change="changeCheck(2);$emit('changeData',newBizParam)" v-model="newBizParam.selectProductStockQty.enabled"></el-checkbox>
            <span class="txt">规则2：限制同一人员采集库存时，提交每个产品库存数量上限 
                <el-tooltip class="item" effect="dark" content="" placement="right-start">
                    <i class="el-icon-question"></i>
                    <div slot="content">其他规则说明:<br>不同业务员提交的库存数据，同客户同日期同产品的信息会进行拦裁，提示"该产品当日已采集，请调整"<br>比如: 张三在10月17日采集了心连心大药房的阿莫西林，李四同天不可再次采集，可以改天或者改产品采集。</div>
                </el-tooltip>
                </span>
        </div>
        <div class="rule-child" v-if="newBizParam.selectProductStockQty.enabled">
            <div class="rule" v-for="(item, index) in newBizParam.selectProductStockQty.ruleItemList" :key="index">
                <el-checkbox @change="item.sumLimitMax = null; $forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                <span class="txt"><i class="theme-color">{{item.customerType}}</i>最多提交<span
                        :class="!item.sumLimitMax && item.enabled && isOpenCheck ? 'red-border txt' : 'txt'"><el-input
                            @input="$forceUpdate();$emit('changeData',newBizParam)" class="rule-input-box" v-model="item.sumLimitMax"
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text" :min="1" :maxlength="7"
                            :disabled="!item.enabled"></el-input></span>盒</span>
                <p class="tips" v-if="!item.sumLimitMax && item.enabled && isOpenCheck">请将规则填写完整</p>
            </div>
        </div>
        <!-- 规则2 end-->


        <!-- 规则3 start -->
        <div class="rule">
            
            <el-checkbox @change="changeCheck(3);$emit('changeData',newBizParam)"  v-model="newBizParam.dayCustomerSumAndSame.enabled"></el-checkbox>
            <span class="txt">规则3：限制</span>
            <div :class="!newBizParam.dayCustomerSumAndSame.isSamePerson&&newBizParam.dayCustomerSumAndSame.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.dayCustomerSumAndSame.enabled" class="w130" v-model="newBizParam.dayCustomerSumAndSame.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt"><i class="theme-color">同一天</i>采集<i class="theme-color">企业客户</i>的频次</span>
            <p class="tips" v-if="!newBizParam.dayCustomerSumAndSame.isSamePerson&&newBizParam.dayCustomerSumAndSame.enabled&&isOpenCheck">请将规则填写完整</p>
        </div>
        <div class="rule-child" v-if="newBizParam.dayCustomerSumAndSame.enabled">
            <div class="rule" v-for="(item,index) in newBizParam.dayCustomerSumAndSame.ruleItemList" :key="index">
                <el-checkbox @change="item.sameLimitMax=null;item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                    :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次，同一家不可超过<span :class="!item.sameLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sameLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                    :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                <p class="tips" v-if="(!item.sameLimitMax||!item.sumLimitMax)&&item.enabled&&isOpenCheck">请将规则填写完整</p>
            </div>
        
        </div>
        <!-- 规则3 end-->

        <!-- 规则4 start-->
        <div class="rule">
            
            <el-checkbox @change="changeCheck(4);$emit('changeData',newBizParam)" v-model="newBizParam.dayCustomerSameSum.enabled"></el-checkbox>
            <span class="txt">规则4：限制</span>
            <div :class="!newBizParam.dayCustomerSameSum.isSamePerson&&newBizParam.dayCustomerSameSum.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.dayCustomerSameSum.enabled" class="w130" v-model="newBizParam.dayCustomerSameSum.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt"><i class="theme-color">同一天</i>采集<i class="theme-color">同一家企业客户</i>的频次</span>
            <p class="tips" v-if="!newBizParam.dayCustomerSameSum.isSamePerson&&newBizParam.dayCustomerSameSum.enabled&&isOpenCheck">请将规则填写完整</p>
        </div>
        <div class="rule-child" v-if="newBizParam.dayCustomerSameSum.enabled">
            <div class="rule" v-for="(item,index) in newBizParam.dayCustomerSameSum.ruleItemList" :key="index">
                <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)"  v-model="item.enabled"></el-checkbox>
                <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他'}}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input @input="$forceUpdate();$emit('changeData',newBizParam)"  class="rule-input-box" v-model="item.sumLimitMax" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                    :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
            </div>
        </div>
        <!-- 规则4 end-->





        <!-- 规则5 start -->
        <div class="rule">
            <el-checkbox @change="changeCheck(5);$emit('changeData',newBizParam)"  v-model="newBizParam.monthCustomerSameStaff.enabled"></el-checkbox>
            <span class="txt">规则5：限制</span>
            <div :class="!newBizParam.monthCustomerSameStaff.isSamePerson&&newBizParam.monthCustomerSameStaff.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="true" class="w130" v-model="newBizParam.monthCustomerSameStaff.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt"><i class="theme-color">同一月</i>采集<i class="theme-color">同一家企业客户</i>的频次</span>
            <p class="tips" v-if="!newBizParam.monthCustomerSameStaff.isSamePerson&&newBizParam.monthCustomerSameStaff.enabled&&isOpenCheck">请将规则填写完整</p>
        </div>
        <div class="rule-child" v-if="newBizParam.monthCustomerSameStaff.enabled">
            <div class="rule" v-for="(item,index) in newBizParam.monthCustomerSameStaff.ruleItemList" :key="index">
                <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                    :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
            </div>
        
        </div>
        <!-- 规则5 end-->

        <!-- 规则6 start-->
        <div class="rule">
            <el-checkbox @change="changeCheck(6);$emit('changeData',newBizParam)" v-model="newBizParam.monthCustomerDifferentStaff.enabled"></el-checkbox>
            <span class="txt">规则6：限制</span>
            <div :class="!newBizParam.monthCustomerDifferentStaff.isSamePerson&&newBizParam.monthCustomerDifferentStaff.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="true" class="w130" v-model="newBizParam.monthCustomerDifferentStaff.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt"><i class="theme-color">同一月</i>采集<i class="theme-color">同一家企业客户</i>的频次</span>
            <p class="tips" v-if="!newBizParam.monthCustomerDifferentStaff.isSamePerson&&newBizParam.monthCustomerDifferentStaff.enabled&&isOpenCheck">请将规则填写完整</p>
        </div>
        <div class="rule-child" v-if="newBizParam.monthCustomerDifferentStaff.enabled">
            <div class="rule" v-for="(item,index) in newBizParam.monthCustomerDifferentStaff.ruleItemList" :key="index">
                <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                    :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
            </div>
        </div>
        <!-- 规则6 end-->



    </section>
</template>
  
<script>
export default {
    props: ['bizParam1'],
    data() {
        return {
            isOpenCheck: false,
            newBizParam: null,
            isSamePersonOption:[
                {
                    value: 'Y',
                    label: '同一人员',
                },
                {
                    value: 'N',
                    label: '不同人员',
                },
            ],

        };
    },
    watch: {
        bizParam1: {
            deep: true,
            handler(newBizParam) {
                if (!this.$route.query.guid && this.$route.query.type != 3) return
                this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
                this.newBizParam.dayCustomerSumAndSame.ruleItemList = this.newBizParam.dayCustomerSumAndSame.ruleItemList.splice(0,3)
                
                this.$forceUpdate();
            }
        },
    },
    created() {
        if (this.$route.query.guid||this.$route.query.type==3) return
        this.newBizParam = this.bizParam1;
        this.changeCheck(0);
    },
    methods: {
        changeCheck(i) {
            // 规则1
            if (!this.newBizParam.dayBizDataSum.enabled && (i == 1 || i == 0)) {
                this.newBizParam.dayBizDataSum = {
                    "enabled": false,
                    "limitMax": null
                }
            }
            //规则2
            if (!this.newBizParam.selectProductStockQty.enabled && (i == 2 || i == 0)) {
                this.newBizParam.selectProductStockQty = {
                    "enabled": false,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "单体药店",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "连锁总部",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "连锁门店",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "未定义类型的药店",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "商业公司",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "医院",
                            "sumLimitMax": null
                        }
                    ]
                } 
            }
            //规则3
            if (!this.newBizParam.dayCustomerSumAndSame.enabled &&( i == 3|| i == 0)) {
              
                this.newBizParam.dayCustomerSumAndSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                    ]
                }
             
            }
            //规则4
            if (!this.newBizParam.dayCustomerSameSum.enabled && (i == 4|| i == 0)) {
                this.newBizParam.dayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null
                        },
                    ]
                }
            }
            //规则5
            if (!this.newBizParam.monthCustomerSameStaff.enabled && (i == 5 || i == 0)) {
                this.newBizParam.monthCustomerSameStaff = {
                    "enabled": false,
                    "isSamePerson": 'Y',
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sumLimitMax": null,
                            "isSamePersonExecute": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null,
                            "isSamePersonExecute": null
                        }
                    ]
                }
            }
            //规则6
            if (!this.newBizParam.monthCustomerDifferentStaff.enabled && (i == 6 || i == 0)) {
                this.newBizParam.monthCustomerDifferentStaff = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sumLimitMax": null,
                            "isSamePersonExecute": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null,
                            "isSamePersonExecute": null
                        }
                    ]
                }
            }
            this.$forceUpdate();
        },
        checkResult() {
            this.isOpenCheck = true;
            this.$forceUpdate();
            let { dayBizDataSum, selectProductStockQty,dayCustomerSumAndSame,dayCustomerSameSum,monthCustomerSameStaff,monthCustomerDifferentStaff  } = this.newBizParam;
            console.log(this.newBizParam)
            //规则1 校验
            if (dayBizDataSum.enabled && !dayBizDataSum.limitMax) return;
            //规则2 校验
            try {
                let count = 0;
                selectProductStockQty.ruleItemList.forEach(k => {
                    if (selectProductStockQty.enabled&&!k.enabled) {
                        count++;
                    }

                    if (count == 6) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则5 校验
            try {
                let count = 0;
                monthCustomerSameStaff.ruleItemList.forEach(k => {
                    if (monthCustomerSameStaff.enabled && !k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax )) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则6 校验
            try {
                let count = 0;
                monthCustomerDifferentStaff.ruleItemList.forEach(k => {
                    if (monthCustomerDifferentStaff.enabled && !k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax )) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则3 校验
            if (dayCustomerSumAndSame.enabled && !dayCustomerSumAndSame.isSamePerson) return;
            try {
                let count = 0;
                dayCustomerSumAndSame.ruleItemList.forEach(k => {
                    if (dayCustomerSumAndSame.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax || !k.sameLimitMax)) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则4 校验
            if (dayCustomerSameSum.enabled && !dayCustomerSameSum.isSamePerson) return;
            try {
                let count = 0;
                dayCustomerSameSum.ruleItemList.forEach(k => {
                    if (dayCustomerSameSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
        

            return true;
        }
    }
};
</script>
  
<style scoped>
.rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
}

.w260 {
    width: 260px;
}

.w130 {
    width: 130px;
}

.rule-input-box {
    width: 90px;
}

.txt {
    margin: 0 10px;
}

.theme-color {
    color: #4FA1A4;
    font-style: normal;
}

.rule-child {
    padding-left: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #fafafa;
    margin-bottom: 10px;
}

.tips {
    color: red;
    font-size: 12px;
}

.red-border {
    border: 1px solid red;
    border-radius: 4px;
}

.red-border /deep/ .el-input__inner {
    border: 0 none;
}

span {
    display: inline-block;
}
.rule-child .rule:last-child{
    margin-bottom: 0px;
}

</style>
  